import { motion } from 'framer-motion';

const clients = [
  { name: 'Nexus', logo: 'Nexus' },
  { name: 'Darwinbox', logo: 'Darwinbox' },
  { name: 'Bajaj Electronics', logo: 'Bajaj Electronics' },
  { name: 'Client 4', logo: 'Fortune 500' },
  { name: 'Client 5', logo: 'Enterprise Co' },
  { name: 'Client 6', logo: 'Global Corp' },
];

export const ClientsSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white border-y border-gray-100" data-testid="clients-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-muted-foreground text-sm uppercase tracking-wider">
            Trusted by Industry Leaders
          </span>
        </motion.div>

        {/* Client Logos - Infinite Scroll */}
        <div className="relative overflow-hidden">
          <div className="flex animate-marquee">
            {[...clients, ...clients].map((client, index) => (
              <div
                key={`${client.name}-${index}`}
                className="flex-shrink-0 mx-12 flex items-center justify-center"
                data-testid={`client-logo-${index}`}
              >
                <div className="client-logo px-8 py-6 border border-gray-200 bg-white hover:border-gold transition-all cursor-pointer min-w-[180px]">
                  <span className="font-heading text-xl text-navy whitespace-nowrap">
                    {client.logo}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Indicators */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-muted-foreground">
            Join <span className="text-navy font-semibold">50+ brands</span> that trust DFAIRS for their event needs
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsSection;
